function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9546 32H17.8179L28.0114 11.3379L38.2074 32H40.0707L28.0114 7.56208L15.9546 32ZM55.4155 3.67983L45.6372 15.2176L35.8589 3.67983H34.5769L45.1467 16.17V28.289H46.1276V16.17L56.6948 3.67983H55.4155ZM58.7605 3.67983V28.289H72.6728V27.3418H59.7415V3.67983H58.7605ZM79.9183 16.8655C79.0774 11.5507 81.9165 6.31384 86.8264 4.09245C89.7173 4.41165 92.3902 5.77926 94.3651 7.95134C96.3737 10.1598 97.4792 13.0144 97.4792 15.9857C97.4792 20.6854 94.7206 24.9621 90.4439 26.911C85.0825 26.3168 80.7617 22.1984 79.9183 16.8655ZM73.5188 15.9857C73.5188 9.61479 78.5377 4.39088 84.8385 4.04055C80.471 6.78096 78.1302 11.8414 78.9503 17.0212C79.7755 22.2347 83.5955 26.3349 88.6351 27.565C87.6205 27.8427 86.5746 27.9828 85.5159 27.9828C78.901 27.9802 73.5188 22.598 73.5188 15.9857ZM72.5378 15.9857C72.5378 23.1222 78.3456 28.93 85.4821 28.93C87.2572 28.93 88.9803 28.5745 90.6048 27.8712C90.6204 27.866 90.636 27.8608 90.6515 27.8556C90.7527 27.8115 90.8539 27.7648 90.9526 27.7181L91.1472 27.6273C91.1705 27.6169 91.1965 27.6039 91.2199 27.5935C91.238 27.5858 91.2536 27.5754 91.2666 27.565C95.6834 25.354 98.4264 20.9216 98.4264 15.9883C98.4264 9.64074 93.7059 4.14695 87.444 3.19196C87.4336 3.18936 87.4232 3.18676 87.4129 3.18676C87.1741 3.15043 86.9509 3.12189 86.7329 3.10113C86.7174 3.09853 86.6992 3.09853 86.6836 3.10113C86.2736 3.0648 85.8714 3.04404 85.4847 3.04404C78.3456 3.04144 72.5378 8.84665 72.5378 15.9857ZM12.2229 32H14.0861L28.0114 3.77585L41.9392 32H43.8024L28.0139 0L14.6 27.1861L1.6349 15.9857L15.8767 3.67983H14.3872L0.980942 15.2643V3.67983H0V28.289H0.980942V16.7072L14.1536 28.0892L12.2229 32Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 98.4264,
  y1: 16,
  x2: 0,
  y2: 16,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B29164"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.489583,
  stopColor: "#FFDA8A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B29164"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 32,
    viewBox: "0 0 99 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.18abe98e.svg";
export { ForwardRef as ReactComponent };